export const validateRegularExpression = (pagePattern: string) => {
  const errorMessage = "Invalid regular expression";
  try {
    new RegExp(pagePattern);
    return true;
  } catch (e) {
    return errorMessage;
  }
};
